import { render } from "./GroupProfile.vue?vue&type=template&id=79afd2b0"
import script from "./GroupProfile.vue?vue&type=script&lang=js"
export * from "./GroupProfile.vue?vue&type=script&lang=js"

import "./GroupProfile.vue?vue&type=style&index=0&id=79afd2b0&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__